const sort = {
    data() {
        return {
            sortMarks: null,
        }
    },
    methods: {
        markSvgs(ref) {
            const target = this.$refs[`${ref}`]

            this.sortMarks.forEach((el) => {
                el.classList.remove('sort-svg_active')
            })
            target.classList.add('sort-svg_active')
        },
        markSvgsComponents(ref) {
            const target = this.$refs[`${ref}`].$el

            if (target.classList.contains('sort-svg_active')) {
                target.classList.remove('sort-svg_active')
                return false
            }

            this.sortMarks.forEach((el) => {
                el.classList.remove('sort-svg_active')
            })

            target.classList.add('sort-svg_active')
            return true
        },
    },
    mounted() {
        this.sortMarks = document.querySelectorAll('.sort-svg')
    },
}

export default sort
